import React from "react";
import ChangePas from "./index";
function ChangePassword() {

  
  return (
    <div>
      <ChangePas />
    </div>
  );
}

export default ChangePassword;
